import { IMEventBus } from 'lib/mp-stjk-im-service'
import { resumeIMContext } from "./ImService.js"

class SendEventTask {
  constructor(
    doctorId, personId
  ) {
    this.doctorId = doctorId;
    this.personId = personId;
    // this.eventType = eventType;
    // this.plan = plan;
    // this.gid = gid;
  }
  execute() {
    // 处理请求
    return resumeIMContext(
      this.doctorId,
      this.personId
    );
  }
}

class SendEventExecutor {
  constructor() {
    this.taskQueue = [];
    this.isExecuting = false;
  }
  addTaskToExecuteQueue(task) {
    this.taskQueue.push(task);
    return new Promise((resolve) => {
      IMEventBus.addListener(task.taskId, (res) => {
        IMEventBus.removeListener(task.taskId);
        resolve(res);
      });
      //  执行器未启动 则启动执行器线性调度
      if (!this.isExecuting) {
        this.isExecuting = true;
        this.executeTask();
      }
    });
  }
  executeTask() {
    if (this.taskQueue.length > 0) {
      const task = this.taskQueue.shift();
      task.execute().then((res) => {
        IMEventBus.trigger(task.taskId, res);
        if (this.taskQueue.length === 0) {
          this.isExecuting = false;
        } else {
          this.executeTask();
        }
      }).catch((e) => {
        wx.hideLoading();
        if (this.taskQueue.length === 0) {
          this.isExecuting = false;
        } else {
          this.executeTask();
        }
      });
    }
  }
}

export { SendEventTask, SendEventExecutor };
